import { ApiClient } from '../../api-client/api-client';

export const getUserStatistics = () => {
  return ApiClient.getStatistics().then((res) => res.data);
};
